import { loadPanelData } from './loadPanelData';
import { PerformanceDatapoint } from 'owa-analytics';
import { Datapoints } from '../datapoints';

let initRequest = null;
export function initializePanelData(forceReload: boolean = false): Promise<void> {
    if (initRequest && !forceReload) {
        return initRequest;
    } else {
        const datapoint = new PerformanceDatapoint(
            Datapoints.todoPerformancePanelLoad.name,
            Datapoints.todoPerformancePanelLoad.options
        );
        initRequest = loadPanelData(datapoint).then(() => datapoint.end());
        return initRequest;
    }
}
